<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button
              v-if="showSubmitForApproval"
              type="primary"
              size="small"
              :disabled="approveDocActionLoading"
              @click="submitForApprovalFromView"
            >提交审批</el-button>
            <el-button
              v-if="showWfApprove"
              type="primary"
              size="small"
              :disabled="approveDocActionLoading"
              @click="wfApproveFromView"
            >审批通过</el-button>
            <el-button
              v-if="showWfReject"
              type="primary"
              size="small"
              :disabled="approveDocActionLoading"
              @click="wfRejectFromView"
            >驳回</el-button>
            <el-button
              v-if="showApproveButton"
              type="primary"
              size="small"
              :disabled="approveDocActionLoading"
              @click="approveFromView"
            >审核</el-button>
            <el-button
              v-if="showUnapproveButton"
              type="primary"
              size="small"
              :disabled="approveDocActionLoading"
              @click="unapproveFromView"
            >弃审</el-button>
            <el-button
              v-if="showWorkflowTrail"
              type="primary"
              size="small"
              @click="trailVisible = true"
            >审批轨迹</el-button>
            <el-button
              v-if="isAuth('sale:salePriceList:update')"
              type="primary"
              size="small"
              :disabled="!canEditDoc || approveDocActionLoading"
              @click="editFromView"
            >修改</el-button>
            <el-button
              v-if="isAuth('sale:salePriceList:delete')"
              type="primary"
              size="small"
              :disabled="!canEditDoc || approveDocActionLoading"
              @click="deleteFromView"
            >删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <p v-if="workflowActionHint" class="workflow-hint">{{ workflowActionHint }}</p>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px">
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="价目表编码" prop="priceListCode">
            <el-input v-model="dataForm.priceListCode" :disabled="formReadonly || codeReadonly || !!dataForm.priceListId" :placeholder="codeReadonly ? '保存时自动生成' : '请输入价目表编码'" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="价目表名称" prop="priceListName">
            <el-input v-model="dataForm.priceListName" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="8">
          <el-form-item label="客户">
            <el-input v-model="dataForm.customerName" readonly placeholder="不选则为通用价目表">
              <el-button v-if="!formReadonly" slot="append" @click="customerSelectorVisible = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" v-if="!formReadonly && dataForm.customerId">
          <el-form-item label-width="0">
            <el-button type="text" @click="clearCustomer">清空客户</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="生效日期" prop="effectiveFrom">
            <el-date-picker v-model="dataForm.effectiveFrom" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="失效日期">
            <el-date-picker v-model="dataForm.effectiveTo" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="优先级" prop="priority">
            <el-input-number v-model="dataForm.priority" :min="0" :precision="0" :disabled="formReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6">
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="!formReadonly" style="margin-bottom:8px;">
        <el-button type="primary" size="small" @click="materialSelectorVisible = true">选择物料</el-button>
      </div>

      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="140" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="price" label="含税单价" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.price" :min="0" :precision="2" :disabled="formReadonly" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="税点(%)" width="150" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.tax" :min="0" :max="100" :precision="2" :disabled="formReadonly" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>

    <customer-selector :visible.sync="customerSelectorVisible" @select="chooseCustomer" />
    <material-selector :visible.sync="materialSelectorVisible" @select-multiple="chooseMaterials" />

    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import CustomerSelector from '../../components/CustomerSelector.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import {
  getSalePriceList,
  saveOrUpdateSalePriceList,
  deleteSalePriceList,
  approveSalePriceList,
  unapproveSalePriceList,
  submitSalePriceList
} from '../../api/sale/salePriceList'
import {
  canShowDirectApproveButton,
  isWorkflowEditable,
  normalizeWorkflowDocUi,
  shouldShowWorkflowTrail
} from '../../utils/workflow'
import request from '../../api/request'

function today() {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return d.getFullYear() + '-' + m + '-' + day
}

function emptyForm() {
  return {
    priceListId: '',
    priceListCode: '',
    priceListName: '',
    customerId: '',
    customerName: '',
    effectiveFrom: today(),
    effectiveTo: '',
    priority: 0,
    remark: '',
    approveStatus: '',
    workflowStatus: 'draft',
    workflowInstance: null,
    myPendingTask: null,
    workflowDocUi: null,
    lines: []
  }
}

export default {
  name: 'SalePriceListDialog',
  components: { WorkflowTrailDialog, CustomerSelector, MaterialSelector },
  props: {
    isAuth: { type: Function, required: true }
  },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      approveDocActionLoading: false,
      workflowDocUiReady: false,
      codeReadonly: false,
      customerSelectorVisible: false,
      materialSelectorVisible: false,
      trailVisible: false,
      dataForm: emptyForm(),
      dataRule: {
        priceListCode: [{ required: true, message: '价目表编码不能为空', trigger: 'blur' }],
        priceListName: [{ required: true, message: '价目表名称不能为空', trigger: 'blur' }],
        effectiveFrom: [{ required: true, message: '生效日期不能为空', trigger: 'change' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    workflowUi() {
      return normalizeWorkflowDocUi(this.dataForm && this.dataForm.workflowDocUi)
    },
    canEditDoc() {
      return isWorkflowEditable(this.dataForm && this.dataForm.workflowStatus, this.dataForm && this.dataForm.approveStatus)
    },
    formReadonly() {
      return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc
    },
    formRules() {
      return this.formReadonly ? {} : this.dataRule
    },
    dialogTitle() {
      if (this.readonly) return '查看价目表'
      return this.dataForm.priceListId ? '修改价目表' : '新增价目表'
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.priceListId
    },
    showDirectApprove() {
      return canShowDirectApproveButton(this.dataForm && this.dataForm.workflowDocUi)
    },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApproveButton() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') {
        return false
      }
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) {
        return false
      }
      if (this.isAuth('sale:salePriceList:approve')) {
        return true
      }
      return this.allowSaveDirectApprove && (this.isAuth('sale:salePriceList:save') || this.isAuth('sale:salePriceList:update'))
    },
    showUnapproveButton() {
      return this.showViewToolbar && this.isAuth('sale:salePriceList:unapprove') && String(this.dataForm.approveStatus) === '2'
    },
    showSubmitForApproval() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) {
        return false
      }
      if (!this.isDocCreator) return false
      return this.isAuth('sale:salePriceList:submit') || this.isAuth('sale:salePriceList:save') || this.isAuth('sale:salePriceList:update')
    },
    showWfApprove() {
      return this.showViewToolbar
        && this.isAuth('workflow:task:approve')
        && this.dataForm.myPendingTask
        && this.dataForm.myPendingTask.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showWorkflowTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar,
        workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi,
        workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    isDocCreator() {
      const uid = (this.$store.state.user || {}).id
      return !!uid && String(this.dataForm.createBy || '') === String(uid)
    },
    isWorkflowSubmitter() {
      const uid = (this.$store.state.user || {}).id
      const inst = this.dataForm.workflowInstance
      return !!uid && !!inst && String(inst.submitBy || '') === String(uid)
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') {
        return ''
      }
      if (ui.inApproval) {
        if (!this.dataForm.myPendingTask && this.isWorkflowSubmitter) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) {
        return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      }
      if (!ui.definitionMatched && ui.directApproveAllowed) {
        return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      }
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) {
        return '已启用多级审批，请先在「审批流程定义」中配置价目表流程后再提交。'
      }
      return ''
    }
  },
  methods: {
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.approveDocActionLoading = false
      this.workflowDocUiReady = false
      this.$nextTick(() => {
        this.dataForm = emptyForm()
        this.dataForm.priceListId = id || ''
        if (id) {
          this.reloadPriceList()
        } else {
          this.resolveCode()
        }
        this.clearFormValidate()
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'salePriceList' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.priceListCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('priceListCode')
        })
        if (this.codeReadonly) {
          this.dataRule.priceListCode = []
        }
      }).catch(() => {})
    },
    clearFormValidate() {
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
    },
    applyBody(body) {
      this.dataForm = {
        ...emptyForm(),
        ...body,
        effectiveFrom: (body.effectiveFrom || '').slice(0, 10),
        effectiveTo: body.effectiveTo ? String(body.effectiveTo).slice(0, 10) : '',
        priority: body.priority != null ? Number(body.priority) : 0,
        lines: (body.lines || []).map(l => ({
          ...l,
          price: l.price != null ? Number(l.price) : null,
          tax: l.tax != null ? Number(l.tax) : null
        }))
      }
      this.workflowDocUiReady = true
    },
    reloadPriceList() {
      if (!this.dataForm.priceListId) return Promise.resolve()
      const priceListId = this.dataForm.priceListId
      return getSalePriceList(priceListId).then(res => {
        if (res.data) {
          this.applyBody(res.data)
        }
      }).catch(() => {})
    },
    editFromView() {
      this.readonly = false
    },
    runAction(requestFn, successMsg, options) {
      const reloadOnSuccess = options && options.reloadOnSuccess
      const closeOnSuccess = options && options.closeOnSuccess
      this.approveDocActionLoading = true
      return requestFn().then(() => {
        this.$message.success(successMsg)
        this.$emit('refreshDataList')
        if (reloadOnSuccess) {
          return this.reloadPriceList()
        }
        if (closeOnSuccess) {
          this.visible = false
        }
      }).catch(() => {
      }).finally(() => {
        this.approveDocActionLoading = false
      })
    },
    approveFromView() {
      this.$confirm('审核后价目表将用于销售取价，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => approveSalePriceList(this.dataForm.priceListId), '审核成功', { reloadOnSuccess: true })
      }).catch(() => {})
    },
    unapproveFromView() {
      this.$confirm('弃审后价目表将不再参与取价，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => unapproveSalePriceList(this.dataForm.priceListId), '弃审成功', { reloadOnSuccess: true })
      }).catch(() => {})
    },
    deleteFromView() {
      if (String(this.dataForm.approveStatus) === '2') {
        return
      }
      this.$confirm('确定删除该价目表?', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => deleteSalePriceList(this.dataForm.priceListId), '删除成功', { closeOnSuccess: true })
      }).catch(() => {})
    },
    submitForApprovalFromView() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert(
          '尚未配置价目表审批流程，请先在「审批流程定义」中新增并启用价目表流程（至少一个审批步骤）后再提交。',
          '未配置审批流程',
          { type: 'warning', confirmButtonText: '我知道了' }
        )
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => submitSalePriceList(this.dataForm.priceListId), '提交成功', { reloadOnSuccess: true })
      }).catch(() => {})
    },
    wfApproveFromView() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.approveDocActionLoading = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过')
          this.$emit('refreshDataList')
          return this.reloadPriceList()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    wfRejectFromView() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.approveDocActionLoading = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回')
          this.$emit('refreshDataList')
          return this.reloadPriceList()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    chooseCustomer(row) {
      this.dataForm.customerId = row.customerId
      this.dataForm.customerName = row.customerName
    },
    clearCustomer() {
      this.dataForm.customerId = ''
      this.dataForm.customerName = ''
    },
    chooseMaterials(materials) {
      const exists = new Set(this.dataForm.lines.map(l => l.materialId))
      ;(materials || []).forEach(m => {
        if (exists.has(m.materialId)) return
        exists.add(m.materialId)
        this.dataForm.lines.push({
          materialId: m.materialId,
          materialCode: m.materialCode,
          materialName: m.materialName,
          specs: m.specs,
          price: m.price != null ? Number(m.price) : null,
          tax: m.tax != null ? Number(m.tax) : null
        })
      })
    },
    removeLine(index) {
      this.dataForm.lines.splice(index, 1)
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.dataForm.lines.length) {
          this.$message.warning('请至少维护一条价目明细')
          return
        }
        for (let i = 0; i < this.dataForm.lines.length; i++) {
          const line = this.dataForm.lines[i]
          if (line.price == null || line.price === '') {
            this.$message.warning(`第${i + 1}行：含税单价不能为空`)
            return
          }
        }
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          effectiveFrom: (this.dataForm.effectiveFrom || '').slice(0, 10),
          effectiveTo: this.dataForm.effectiveTo ? String(this.dataForm.effectiveTo).slice(0, 10) : null,
          customerId: this.dataForm.customerId || null
        }
        if (!payload.priceListId) {
          delete payload.priceListId
        }
        saveOrUpdateSalePriceList(payload).then(() => {
          this.submitLoading = false
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 28px;
}
.doc-dialog-title {
  font-size: 16px;
  font-weight: 600;
}
.workflow-hint {
  margin: 0 0 12px;
  color: #e6a23c;
  font-size: 13px;
}
.trail-empty {
  color: #909399;
  text-align: center;
  padding: 24px 0;
}
</style>
